import React from 'react';
import { Box, Typography, Container, Chip } from '@mui/material';
import './PostPage.css';
import { useParams, Link } from 'react-router-dom';
import { docsPosts } from '../../utils/docsData';
import NavBar from '../../Components/NavBar/navbar';
import FooterSection from '../../Components/Footer/footer';
import MathText from '../../Components/Math/MathText';
import DocsPreviewImage from '../../Components/Docs/DocsPreviewImage';
import { THEME } from '../../theme';

const PostPage = () => {
    const { postId } = useParams();
    const post = docsPosts.find((item) => item.id === postId);

    if (!post) {
        return (
            <>
                <NavBar />
                <Container sx={{ pt: 14, pb: 8 }}>
                    <Typography color={THEME.textMain}>Article not found.</Typography>
                    <Link to="/docs" style={{ color: THEME.primary }}>Back to Docs</Link>
                </Container>
                <FooterSection />
            </>
        );
    }

    return (
        <>
            <NavBar />
            <Container className="blog-post-container">
                <Typography variant="h6" className="blog-articles">
                    EvolveX Docs
                </Typography>
                <Chip label={post.category} size="small" sx={{ mb: 2, bgcolor: THEME.primary, color: '#000' }} />
                <Typography variant="h3" className="blog-title">
                    {post.title}
                </Typography>
                <Typography variant="body2" className="date">
                    {post.author} - {new Date(post.datePublished).toDateString()}
                </Typography>
                <DocsPreviewImage postId={post.id} className="blog-post-preview" alt={`${post.title} preview`} />
                <Box className="highlight-box">
                    <Typography variant="body1" className="highlight-text" component="div">
                        <MathText text={post.description} />
                    </Typography>
                </Box>
                {post.equations && post.equations.map((eq, idx) => (
                    <Box key={idx} sx={{ my: 2, overflowX: 'auto', color: THEME.textMain }}>
                        <MathText text={eq} display />
                    </Box>
                ))}
                <Typography variant="body1" sx={{ color: THEME.secondary, lineHeight: 1.9, mt: 3, whiteSpace: 'pre-wrap' }} component="div">
                    <MathText text={post.content} />
                </Typography>
            </Container>
            <FooterSection />
        </>
    );
};

export default PostPage;
